import { inject, Pipe, PipeTransform } from '@angular/core';
import { Iso2To3 } from '../../../../assets/i18n/languages/iso2to3';
import { LocaleService } from '../../../services/locale.service';

@Pipe({
  name: 'languageCodeToName'
})
export class LanguageCodeToNamePipe implements PipeTransform {
  private readonly localeService = inject(LocaleService);
  private readonly languages: Record<string, string>;
  private readonly countries: Record<string, string>;

  constructor() {
    // FIXME This type hack is needed because instant must return an string but in this case it returns an object (wtf)
    this.languages = this.localeService.instant('languages') as unknown as Record<string, string>;
    this.countries = this.localeService.instant('countries') as unknown as Record<string, string>;
  }

  transform(locale: string): string {
    const [languageCode, countryCode] = locale.split('-')
    const iso3Code = this.buildIso3Code(languageCode);
    const languageName = this.languages[iso3Code] ?? iso3Code

    if (!countryCode) {
      return languageName;
    }

    const countryName = this.countries[countryCode] ?? countryCode

    return `${languageName} (${countryName})`;
  }

  buildIso3Code(languageCode: string): string {
    if (languageCode.length === 2) {
      return Iso2To3[languageCode] ?? languageCode;
    }

    return languageCode
  }
}
